// Конвертация строк и ключей между различными форматами
function strToUint8Array(str: string): Uint8Array {
	return new TextEncoder().encode(str);
}

function uint8ArrayToBase64(arr: Uint8Array): string {
	return btoa(String.fromCharCode.apply(null, arr as unknown as number[]));
}

function pemToBinaryDer(pem: string): Uint8Array {
	const pemHeader = "-----BEGIN PUBLIC KEY-----";
	const pemFooter = "-----END PUBLIC KEY-----";
	const pemContents = pem.substring(pemHeader.length, pem.length - pemFooter.length);
	const binaryDerString = atob(pemContents.replace(/\n/g, ''));
	return new Uint8Array(binaryDerString.split('').map(char => char.charCodeAt(0)));
}

async function importPublicKey(base64Key: string): Promise<CryptoKey> {
	const pem = atob(base64Key);
	const binaryDer = pemToBinaryDer(pem);
	const imported_key = await crypto.subtle.importKey(
		'spki',
		binaryDer,
		{
			name: 'RSA-OAEP',
			hash: 'SHA-256'
		},
		true,
		['encrypt']
	);
	return imported_key;
}


export async function encrypt(publicKeyPem: string, message: string): Promise<string> {
	const publicKey = await importPublicKey(publicKeyPem);
	const encodedMessage = strToUint8Array(message);
	const encryptedMessage = await crypto.subtle.encrypt(
		{
			name: 'RSA-OAEP'
		},
		publicKey,
		encodedMessage
	);
	return uint8ArrayToBase64(new Uint8Array(encryptedMessage));
}

export async function encrypt_bson(publicKeyPem: string, message: object): Promise<string[]> {
	const jsonMessage = JSON.stringify(message);
	const chunks = jsonMessage.match(/.{1,200}/g); // Разделение на части по 200 символов
	if (chunks) {
		const encryptedChunks = await Promise.all(chunks.map(chunk => encrypt(publicKeyPem, chunk)));
		return encryptedChunks;
	}
	return [];
}